import { Select } from "@mantine/core";
import { Clock } from "../icons";

export default function TimeDurationPicker({ formData, onChange }) {
  const data = Array.from({ length: 12 }, (_, i) => {
    const h = i + 1;
    return { value: h.toString(), label: `${h} ${h === 1 ? "hour" : "hours"}` };
  });

  return (
    <Select
      w="100%"
      p={8}
      withAsterisk
      label="Select Duration"
      placeholder="Select duration"
      data={data}
      value={formData.duration}
      onChange={onChange}
      searchable
      leftSection={
        <Clock style={{ color: "#646464" }} width={10} height={10} />
      }
      comboboxProps={{
        withinPortal: true,
        portalProps: { target: "#get-a-quote" },
      }}
    />
  );
}
